import React from "react";
import { Box, Chip, IconButton, Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import SourceBadge from "./sourceBadge";

const ClosedGapCard = ({ item, onEdit }) => {
  const isRejected = item.status === "Rejected";
  const score = Number(item.ai_confidence || 0);
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: isRejected ? "1px solid #fecaca" : "1px solid #bbf7d0",
        background: isRejected ? "#fef2f2" : "#f0fdf4",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
    >
      <Box pr={1.5}>
        <Box display={"flex"} alignItems={"center"}>
          <SourceBadge item={item} />
          <Chip
            label={item.care_gap_category}
            size="small"
            sx={{
              height: 30,
              borderRadius: "999px",
              background: "#fff7ed",
              border: "1px solid #fdba74",
              color: "#9a3412",
              fontWeight: 700,
              fontSize: 12,
              ml: 2,
              "& .MuiChip-label": {
                px: 1.5,
              },
            }}
          />
        </Box>

        {item.type !== "AI" && (
          <Typography
            sx={{
              mt: 1,
              fontSize: 11,
              letterSpacing: "0.08em",
              fontWeight: 700,
              color: "#667085",
            }}
          >
            HEDIS / VBC
          </Typography>
        )}

        <Typography
          sx={{
            mt: 0.9,
            fontSize: 16,
            lineHeight: 1.5,
            color: "#555",
            fontWeight: 400,
          }}
        >
          {item.text}
        </Typography>

        <Typography
          sx={{
            mt: 0.9,
            fontSize: 14,
            lineHeight: 1.5,
            color: "#555",
            fontWeight: 400,
          }}
        >
          Detail: {item.care_gap_detials || "N/A"}
        </Typography>
        <Typography
          sx={{
            mt: 0.9,
            fontSize: 14,
            lineHeight: 1.5,
            color: "#555",
            fontWeight: 400,
          }}
        >
          Notes: {item.care_gap_user_notes || "N/A"}
        </Typography>
        <Typography
          sx={{
            mt: 0.9,
            fontSize: 14,
            lineHeight: 1.5,
            color: "#555",
            fontWeight: 400,
          }}
        >
          AI Score: {`${(score * 100).toFixed(0)}%`}
        </Typography>

        <Box mt={0.8}>
          <Chip
            label={item.status}
            size="small"
            sx={{
              background: isRejected ? "#fee2e2" : "#dcfce7",
              color: isRejected ? "#b91c1c" : "#166534",
              fontWeight: 700,
              borderRadius: "999px",
              fontSize: 12,
              height: 22,
            }}
          />
        </Box>
      </Box>

      <IconButton
        size="small"
        sx={{
          width: 28,
          height: 28,
          borderRadius: "8px",
          border: "1px solid #e5e7eb",
          background: "#ffffff",
          color: "#9ca3af",
          "&:hover": { background: "#f9fafb" },
        }}
        onClick={() => onEdit(item)}
      >
        <Edit sx={{ fontSize: 15 }} />
      </IconButton>
    </Box>
  );
};

export default ClosedGapCard;
